import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import { AutosaveStatus } from '../hooks/estimation/useDetailedEstimate';

interface EstimationFormState {
  isActive: boolean;
  currentStep: string;
  completedSteps: string[];
  isEditMode: boolean;
  formAddress: string;
  formPostcode: string;
  formCity: string;
  stepIsValid: boolean;
  autosaveStatus: AutosaveStatus;
  /** Step IDs that have AI pre-selected items (from SimulReno AI assistant) */
  aiSteps: string[];
}

interface EstimationFormContextValue extends EstimationFormState {
  stepNavRef: React.MutableRefObject<{
    onNext?: () => void;
    onBack?: () => void;
  }>;
  onStepClickRef: React.MutableRefObject<(id: string) => void>;
  update: (partial: Partial<EstimationFormState>) => void;
}

const EstimationFormContext = createContext<EstimationFormContextValue | null>(null);

export const EstimationFormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<EstimationFormState>({
    isActive: false,
    currentStep: '',
    completedSteps: [],
    isEditMode: false,
    formAddress: '',
    formPostcode: '',
    formCity: '',
    stepIsValid: true,
    autosaveStatus: 'idle',
    aiSteps: [],
  });

  const stepNavRef = useRef<{ onNext?: () => void; onBack?: () => void; }>({});
  const onStepClickRef = useRef<(id: string) => void>(() => {});

  const update = useCallback((partial: Partial<EstimationFormState>) => {
    setState(prev => ({ ...prev, ...partial }));
  }, []);

  return (
    <EstimationFormContext.Provider value={{ ...state, stepNavRef, onStepClickRef, update }}>
      {children}
    </EstimationFormContext.Provider>
  );
};

export const useEstimationForm = () => useContext(EstimationFormContext);
